module.exports = __webpack_public_path__ + "img/cadenas.c46c39db.png";